import React from 'react';

const ProductSkeleton = () => {
  return (
    <div className="bg-white rounded-lg overflow-hidden shadow-lg animate-pulse">
      {/* Image Skeleton */}
      <div className="w-full h-64 bg-gray-300"></div>
      
      {/* Content Skeleton */}
      <div className="p-6">
        {/* Category/Badge */}
        <div className="h-4 bg-gray-300 rounded w-20 mb-3"></div>
        
        {/* Title */}
        <div className="h-6 bg-gray-300 rounded w-3/4 mb-2"></div>
        
        {/* Short Description */}
        <div className="space-y-2 mb-4">
          <div className="h-4 bg-gray-200 rounded w-full"></div>
          <div className="h-4 bg-gray-200 rounded w-5/6"></div>
        </div>
        
        {/* Price */}
        <div className="h-8 bg-gray-300 rounded w-32 mb-4"></div>
        
        {/* Button */}
        <div className="h-10 bg-gray-300 rounded w-full"></div>
      </div>
    </div>
  );
};

const ProductSkeletonGrid = ({ count = 6 }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {Array.from({ length: count }).map((_, index) => (
        <ProductSkeleton key={index} />
      ))}
    </div>
  );
};

export { ProductSkeleton, ProductSkeletonGrid };
